
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateClausuradoForm } from '../Validations/ValidationsClausurado';

export default function EditClausuradoForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '',
        fecha: '',
        observaciones: '',
        sepulturaId: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchClausurado = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/clausurados/${id}`);
                setFormData({
                    id: response.data.id || '',
                    fecha: response.data.fecha || '',
                    observaciones: response.data.observaciones || '',
                    sepulturaId: response.data.sepulturaId || ''
                });
            } catch (err) {
                setError('Error al cargar los datos del clausurado.');
            } finally {
                setIsLoading(false);
            }
        };

        if (id) fetchClausurado();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({ ...prevState, [name]: value }));
        setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = await validateClausuradoForm(formData);
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            setError(null);
            try {
                await axios.put(`/clausurados/${id}`, formData);
                navigate('/home/clausurados');
            } catch (err) {
                setError('Error al actualizar el clausurado. Por favor, intente de nuevo.');
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    if (isLoading) return <div className="text-center mt-8">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-4xl mx-auto mt-8 bg-blue-50 p-6 rounded-lg shadow-md">
            <h2 className="text-3xl font-bold mb-6 text-blue-700 text-center">Editar Clausurado</h2>
            <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-6">
                <div>
                    <label className="block mb-1 font-semibold text-blue-700">ID</label>
                    <input
                        type="text"
                        name="id"
                        value={formData.id}
                        className="w-full p-3 border rounded bg-gray-100 cursor-not-allowed"
                        readOnly
                    />
                </div>
                <div>
                    <label className="block mb-1 font-semibold text-blue-700">Fecha</label>
                    <input
                        type="date"
                        name="fecha"
                        value={formData.fecha}
                        onChange={handleChange}
                        className={`w-full p-3 border rounded ${errors.fecha ? 'border-red-500' : 'border-blue-300'}`}
                        required
                    />
                    {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
                </div>
                <div className="col-span-2">
                    <label className="block mb-1 font-semibold text-blue-700">Observaciones</label>
                    <textarea
                        name="observaciones"
                        value={formData.observaciones}
                        onChange={handleChange}
                        className={`w-full p-3 border rounded ${errors.observaciones ? 'border-red-500' : 'border-blue-300'}`}
                        required
                    />
                    {errors.observaciones && <p className="text-red-500 text-xs italic">{errors.observaciones}</p>}
                </div>
                <div>
                    <label className="block mb-1 font-semibold text-blue-700">Sepultura ID</label>
                    <input
                        type="text"
                        name="sepulturaId"
                        value={formData.sepulturaId}
                        onChange={handleChange}
                        className={`w-full p-3 border rounded ${errors.sepulturaId ? 'border-red-500' : 'border-blue-300'}`}
                        required
                    />
                    {errors.sepulturaId && <p className="text-red-500 text-xs italic">{errors.sepulturaId}</p>}
                </div>
                <div className="col-span-2 flex justify-center">
                    <button
                        type="submit"
                        className="w-full max-w-sm bg-blue-600 text-white p-3 rounded-lg hover:bg-blue-700 transition"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Actualizando...' : 'Actualizar Clausurado'}
                    </button>
                </div>
            </form>
        </div>
    );
}



/*
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateClausuradoForm } from '../Validations/ValidationsClausurado'; // Asegúrate de crear esta validación

export default function EditClausuradoForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '',
        fecha: '',
        observaciones: '',
        sepulturaId: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchClausurado = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/clausurados/${id}`);
                setFormData({
                    id: response.data.id || '',
                    fecha: response.data.fecha || '',
                    observaciones: response.data.observaciones || '',
                    sepulturaId: response.data.sepulturaId || ''
                });
            } catch (err) {
                setError('Error al cargar los datos del clausurado.');
            } finally {
                setIsLoading(false);
            }
        };

        if (id) fetchClausurado();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: ''
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Formulario enviado con datos:', formData); // Log para depurar
        const validationErrors = await validateClausuradoForm(formData);
        console.log('Errores de validación:', validationErrors); // Log de validación
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            setError(null);
            try {
                console.log('Actualizando datos en el servidor...');
                await axios.put(`/clausurados/${id}`, formData);
                console.log('Actualización exitosa.');
                navigate('/home/clausurados'); // Redirigir al listado después de guardar
            } catch (err) {
                setError('Error al actualizar el clausurado. Por favor, intente de nuevo.');
                console.error('Error updating clausurado:', err);
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors); // Mostrar errores si la validación falla
        }
    };

    if (isLoading) return <div className="text-center mt-8">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-2xl mx-auto mt-8">
            <h2 className="text-2xl font-bold mb-4">Editar Clausurado</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block mb-1">ID</label>
                    <input
                        type="text"
                        name="id"
                        value={formData.id}
                        className="w-full p-2 border rounded"
                        required
                        readOnly
                    />
                </div>
                <div>
                    <label className="block mb-1">Fecha</label>
                    <input
                        type="date"
                        name="fecha"
                        value={formData.fecha}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.fecha ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
                </div>
                <div>
                    <label className="block mb-1">Observaciones</label>
                    <textarea
                        name="observaciones"
                        value={formData.observaciones}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.observaciones ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.observaciones && <p className="text-red-500 text-xs italic">{errors.observaciones}</p>}
                </div>
                <div>
                    <label className="block mb-1">Sepultura ID</label>
                    <input
                        type="text"
                        name="sepulturaId"
                        value={formData.sepulturaId}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.sepulturaId ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.sepulturaId && <p className="text-red-500 text-xs italic">{errors.sepulturaId}</p>}
                </div>
                <button
                    type="submit"
                    className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
                    disabled={isLoading}
                >
                    {isLoading ? 'Actualizando...' : 'Actualizar Clausurado'}
                </button>
            </form>
        </div>
    );
}
*/